module.exports = __webpack_public_path__ + "img/plant.8b5c2de7.svg";